export function generateUUID() {
    // rfc4122 version 4 compliant
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
    })
}

export function getSessionId() {
    try {
        let sessionId = sessionStorage.getItem('session_id')
        if (!sessionId) {
            sessionId = composeSessionId()
            sessionStorage.setItem('session_id', sessionId)
        }
        return sessionId
    } catch (e) {
        return composeSessionId()
    }
}

function composeSessionId(): string {
    return Math.round(Math.random() * Math.pow(10, 17))
        .toString()
        .slice(0, 16)
}
